<script lang="ts">
  import { Icon } from '@bond/components'
</script>

<div class="container">
  <img
    src="/images/bruce-studios-app-logo-gradient-white.svg"
    alt="Bruce Studios Logo"
  />
  <div class="rating">
    <div class="title">Bruce Studios</div>
    <div class="subtitle">4.8, 6000+ ratings</div>
    <div class="stars">
      {#each Array(5) as _, index (index)}
        <Icon icon="ph-star-fill" />
      {/each}
    </div>
  </div>
</div>

<style lang="scss">
  .container {
    display: flex;
    align-items: center;
    gap: 1em;

    img {
      height: 72px;
      width: 72px;
      border-radius: 12px;
    }

    .rating {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 0.25em;

      .title {
        font-weight: 600;
      }

      .subtitle {
        opacity: 0.75;
      }

      .stars {
        display: flex;
        --icon-margin: 0;
        --icon-color: darkorange;
      }
    }
  }
</style>
